// imported to PokeList for filtering function
const FilterTypes = {
  TYPE: 1,
  ABILITY: 2,
}

export default FilterTypes;